import {
  ContactApi,
  ContactComunicationApi,
  ContactPersonalDataApi,
  ContactSocialDataApi,
} from "../../../Shared/Constants/api";

import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";
import {
  getAllContactDataUpdateObject,
  getContacEntitiesUpdateObject,
  getContactComunicationDataUpdateObject,
  getContactPersonalDataUpdateObject,
  getContactSocialDataUpdateObject,
  getContactUpdatenObject,
} from "../Data/ContactWrappers";

export const updateAllContactApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactApi}/${id}/all`,
      getAllContactDataUpdateObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const updateContactApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactApi}/${id}`,
      getContactUpdatenObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const updateContactPersonalDataApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactPersonalDataApi}/${id}`,
      getContactPersonalDataUpdateObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
export const updateContactSocialDataApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactSocialDataApi}/${id}`,
      getContactSocialDataUpdateObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
export const updateContactComunicationDataApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactComunicationApi}/${id}`,
      getContactComunicationDataUpdateObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const updateContactEntitiesDataApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactApi}/${id}/entities`,
      getContacEntitiesUpdateObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
export const updateContactAsesorsDataApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ContactApi}/${id}/entities`,
      getContacEntitiesUpdateObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const updateAvatar = async (data) => {
  try {     
    let response = await axiosInstance.post(
      `${ContactApi}/avatar/social`,data
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
